<template>
  <div>
    <Layout1 v-if="item.layout === 1" />
    <Layout2 v-if="item.layout === 2" />
  </div>
</template>

<script>
import Layout1 from "./Layout1";
import Layout2 from "./Layout2";
import {mapState} from "vuex";

export default {
  components: {
    Layout1,
    Layout2
  },
  computed: {
    ...mapState({
      venue_hire: state => state.ServiceMenu.venture_hire,
      branch_id: state => state.Branch.branch_id
    })
  },
  data: () => ({
    ventureList: ["venue hire area", "elevator", "staircase", "escalator"],
    item: {
      layout: 1 // change this to developer
    }
  })
};
</script>

<style lang="scss" scoped>
</style>
